import { Avatar, Box, Text } from '@wix/design-system';
import React, { FC } from 'react';

import { headerFullPageDataHooks } from '../HeaderFullPage.dataHooks';
import style from '../styles.scss';
import s from './styles.scss';

interface CopilotRedesignTitleProps {
  isLiveChat: boolean;
  agent?: { fullName: string; profileImage?: string };
}

export const CopilotRedesignTitle: FC<CopilotRedesignTitleProps> = ({ isLiveChat, agent }) => {
  if (!isLiveChat || !agent) {
    return <Box />;
  }

  return (
    <Box className={style.copilotAppHeaderTitleWrapper} gap="1" verticalAlign="middle">
      <Avatar
        size="size30"
        shape="circle"
        name={agent.fullName}
        imgProps={{ src: agent.profileImage }}
        dataHook={headerFullPageDataHooks.agentAvatar()}
      />
      <Text className={s.agentName} dataHook={headerFullPageDataHooks.secondaryTitle()}>
        {agent.fullName}
      </Text>
    </Box>
  );
};
